import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../../context/AuthContext";
import { ENDPOINTS } from "../../../../../config/api";
import SearchSelect from "../../../../../components/private/searchselect";
import "./seguimiento_financiero.css";

const SeguimientoFinancieroGeneral = () => {

  const navigate = useNavigate();
  const { authFetch } = useAuth();

  const [datos, setDatos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // =========================
  // FILTROS
  // =========================

  const [filtroPrograma, setFiltroPrograma] = useState("");
  const [filtroAnio, setFiltroAnio] = useState("");
  const [filtroMes, setFiltroMes] = useState("");

  const [programOptions, setProgramOptions] = useState([]);

  // ==========================================
  // CARGAR SEGUIMIENTO FINANCIERO GENERAL
  // ==========================================

  useEffect(() => {

    const cargarSeguimiento = async () => {

      try {

        setLoading(true);
        setError("");

        const data = await authFetch(
          ENDPOINTS.get_seguimiento_financiero_general
        );

        if (!data.success) {
          throw new Error(
            data.message ||
            "No fue posible cargar el seguimiento financiero."
          );
        }

        const rows = data.data || [];

        setDatos(rows);

        const uniquePrograms = [

          ...new Map(

            rows.map((item) => [

              item.program_id,

              {
                value: item.program_id,
                label: `${item.program_name} - ${item.area_name}`
              }

            ])

          ).values()

        ];

        setProgramOptions(uniquePrograms);

      } catch (err) {

        console.error(
          "Error cargando seguimiento financiero:",
          err
        );

        setError(
          err.message ||
          "Error al cargar el seguimiento financiero."
        );

      } finally {

        setLoading(false);

      }

    };

    cargarSeguimiento();

  }, [authFetch]);


  // ==========================================
  // FILTRADO
  // ==========================================

  const datosFiltrados = datos.filter((item) => {

    const matchesPrograma =
      filtroPrograma === "" ||
      String(item.program_id) ===
      String(filtroPrograma);


    const fechaEjecucion = String(
      item.mes_año_ejecucion || ""
    );


    const anioEjecucion =
      fechaEjecucion.substring(0, 4);


    const mesEjecucion =
      fechaEjecucion.substring(5, 7);


    const matchesAnio =
      filtroAnio === "" ||
      anioEjecucion === filtroAnio;


    const matchesMes =
      filtroMes === "" ||
      parseInt(mesEjecucion, 10) ===
      parseInt(filtroMes, 10);


    return (
      matchesPrograma &&
      matchesAnio &&
      matchesMes
    );

  });

  // ==========================================
  // FORMATO MONEDA
  // ==========================================

  const formatoMoneda = (valor) => {

    if (
      valor === null ||
      valor === undefined ||
      valor === ""
    ) {
      return "-";
    }

    const valorLimpio = String(valor).split(".")[0];

    return `$${valorLimpio.replace(
      /\B(?=(\d{3})+(?!\d))/g,
      "."
    )}`;

  };

  // ==========================================
  // LOADING
  // ==========================================

  if (loading) {

    return (

      <div className="container-fluid mt-4">

        <h2>Seguimiento Financiero</h2>

        <div className="alert alert-info mt-3">
          Cargando información...
        </div>

      </div>

    );

  }

  // ==========================================
  // ERROR
  // ==========================================

  if (error) {

    return (

      <div className="container-fluid mt-4">

        <h2>Seguimiento Financiero</h2>

        <div className="alert alert-danger mt-3">
          {error}
        </div>

      </div>

    );

  }

  // ==========================================
  // VISTA
  // ==========================================

  return (

    <div className="container-fluid mt-4">

      {/* ================================= */}
      {/* ENCABEZADO */}
      {/* ================================= */}

      <div className="d-flex justify-content-between align-items-center mb-4">

        <h2>Seguimiento Financiero General</h2>

        <button className="btn btn-outline-pink" onClick={() => navigate(-1)}>
          <i className="bi bi-arrow-left me-2"></i>
          Volver
        </button>

      </div>

      {/* ================================= */}
      {/* FILTROS */}
      {/* ================================= */}

      <div className="row mb-4">

        {/* PROGRAMA */}

        <div className="col-md-4">

          <label className="m-1">
            Programa
          </label>

          <SearchSelect
            options={[
              {
                value: "",
                label: "Todos"
              },
              ...programOptions
            ]}
            value={filtroPrograma}
            onChange={(val) => {

              setFiltroPrograma(val);

            }}
            placeholder="Buscar programa..."
          />

        </div>


        {/* AÑO */}

        <div className="col-md-4">

          <label className="m-1">
            Año
          </label>

          <input
            type="text"
            className="form-control"
            maxLength={4}
            value={filtroAnio}
            onChange={(e) => {

              setFiltroAnio(
                e.target.value
              );

            }}
          />

        </div>


        {/* MES */}

        <div className="col-md-4">

          <label className="m-1">
            Mes
          </label>

          <select
            className="form-select"
            value={filtroMes}
            onChange={(e) => {

              setFiltroMes(
                e.target.value
              );

            }}
          >

            <option value="">
              Todos
            </option>

            <option value="1">
              Enero
            </option>

            <option value="2">
              Febrero
            </option>

            <option value="3">
              Marzo
            </option>

            <option value="4">
              Abril
            </option>

            <option value="5">
              Mayo
            </option>

            <option value="6">
              Junio
            </option>

            <option value="7">
              Julio
            </option>

            <option value="8">
              Agosto
            </option>

            <option value="9">
              Septiembre
            </option>

            <option value="10">
              Octubre
            </option>

            <option value="11">
              Noviembre
            </option>

            <option value="12">
              Diciembre
            </option>

          </select>

        </div>

      </div>

      {/* ================================= */}
      {/* SIN DATOS */}
      {/* ================================= */}

      {datos.length === 0 ? (

        <div className="alert alert-warning">
          No hay registros de seguimiento financiero.
        </div>

      ) : (

        <div className="card">

          <div className="card-header">
            <h5 className="mb-0">
              Seguimiento financiero
            </h5>
          </div>

          <div className="card-body">

            <div className="seguimiento-financiero-scroll">

              <table className="table table-bordered table-hover align-middle seguimiento-financiero-table">

                <thead>

                  <tr>

                    <th>Programa</th>
                    <th>Contrato</th>
                    <th>Año</th>
                    <th>Mes</th>
                    <th>Desembolso</th>

                    <th>Ppto Ingresos mes</th>
                    <th>Esperado mes</th>
                    <th>Ingresos reales mes</th>
                    <th>Ppto acum</th>
                    <th>Esperado acum</th>
                    <th>Ingresos acum.</th>

                    <th>Ppto C&G mes</th>
                    <th>Esperado mes</th>
                    <th>C&G mes</th>
                    <th>Ppto acum</th>
                    <th>Esperado acum</th>
                    <th>C&G acum.</th>

                    <th>Resultado mes</th>
                    <th>Resultado acumulado</th>

                    <th>Ppto Admón</th>
                    <th>Esperado Admón</th>
                    <th>Admón mes</th>
                    <th>Ppto Admón acum</th>
                    <th>Esperado Admón acum</th>
                    <th>Admón acum.</th>

                    <th>Acciones</th>

                  </tr>

                </thead>

                <tbody>

                  {datosFiltrados.map((item) => (

                    <tr key={item.id}>

                      <td>
                        {item.program_name || "-"}
                      </td>

                      <td>
                        {item.contrato_convenio || "-"}
                      </td>

                      <td>
                        {item.anio_ejecucion || "-"}
                      </td>

                      <td>
                        {item.mes_ejecucion || "-"}
                      </td>

                      <td>
                        {item.desembolso || "-"}
                      </td>

                      <td className="text-end">
                        {formatoMoneda(item.ppto_ingresos_mes)}
                      </td>

                      <td className="text-end">
                        {formatoMoneda(item.esperado_ingresos_mes)}
                      </td>

                      <td className="text-end">
                        {formatoMoneda(item.ingresos_reales_mes)}
                      </td>

                      <td className="text-end">
                        {formatoMoneda(item.ppto_ingresos_acum)}
                      </td>

                      <td className="text-end">
                        {formatoMoneda(item.esperado_ingresos_acum)}
                      </td>

                      <td className="text-end">
                        {formatoMoneda(item.ingresos_reales_acum)}
                      </td>

                      <td className="text-end">
                        {formatoMoneda(item.ppto_cg_mes)}
                      </td>

                      <td className="text-end">
                        {formatoMoneda(item.esperado_cg_mes)}
                      </td>

                      <td className="text-end">
                        {formatoMoneda(item.cg_mes)}
                      </td>

                      <td className="text-end">
                        {formatoMoneda(item.ppto_cg_acum)}
                      </td>

                      <td className="text-end">
                        {formatoMoneda(item.esperado_cg_acum)}
                      </td>

                      <td className="text-end">
                        {formatoMoneda(item.cg_acum)}
                      </td>

                      <td className="text-end">
                        {formatoMoneda(item.resultado_mes)}
                      </td>

                      <td className="text-end">
                        {formatoMoneda(item.resultado_acumulado)}
                      </td>

                      <td className="text-end">
                        {formatoMoneda(item.ppto_admon)}
                      </td>

                      <td className="text-end">
                        {formatoMoneda(item.esperado_admon)}
                      </td>

                      <td className="text-end">
                        {formatoMoneda(item.admon_mes)}
                      </td>

                      <td className="text-end">
                        {formatoMoneda(item.ppto_admon_acum)}
                      </td>

                      <td className="text-end">
                        {formatoMoneda(item.esperado_admon_acum)}
                      </td>

                      <td className="text-end">
                        {formatoMoneda(item.admon_acum)}
                      </td>

                      <td className="text-center">

                        <button type="button" className="btn btn-outline-pink btn-sm"
                          onClick={() =>navigate(`/session/mod_administrativa/informacion_general/seguimiento_financiero/seguimiento_financiero/${item.id_informacion_general}`)}
                          title="Ver seguimiento">

                          <i className="bi bi-eye"></i>

                        </button>

                      </td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          </div>

        </div>

      )}

    </div>

  );

};

export default SeguimientoFinancieroGeneral;